var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6124 12C1.17534 12 0.797342 11.8439 0.478405 11.5318C0.159469 11.2197 0 10.8497 0 10.422V1.59538C0 1.16763 0.159469 0.794798 0.478405 0.476879C0.797342 0.15896 1.17534 0 1.6124 0H6.27243L7.4773 1.17919H13.3068C13.7556 1.17919 14.1395 1.33815 14.4585 1.65607C14.7774 1.97399 14.9369 2.34682 14.9369 2.77457H1.6124V10.5087L3.41971 3.81503H16L14.175 10.5087C13.9978 11.0636 13.7438 11.4509 13.4131 11.6705C13.0823 11.8902 12.6334 12 12.0664 12H1.6124Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.0be6b54dc74d6b86f5fcccaff2885724.svg";
export { ForwardRef as ReactComponent };